import React from 'react';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Stanley Uchendu',
      role: 'CEO',
      image: '/images/stanley-uchendu.jpg', // You'll need to add this image
      description: 'Visionary leader with expertise in AI strategy and business transformation.'
    }
  ];

  return (
    <section className="bg-white py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl nvidia-heading text-black mb-4">
            Meet Our <span className="text-nvidia-green">Leadership</span>
          </h2>
          <p className="text-xl nvidia-body text-gray-600 max-w-3xl mx-auto">
            Combining expertise in AI technology and business strategy to deliver innovative solutions.
          </p>
        </div>
        
        <div className="flex justify-center">
          {teamMembers.map((member, index) => (
            <div key={index} className="flex flex-col items-center max-w-md">
              <div className="mb-6 relative">
                <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-nvidia-green shadow-lg">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <h3 className="text-2xl nvidia-heading text-black mb-2">{member.name}</h3>
              <p className="text-lg nvidia-subheading text-nvidia-green mb-3">{member.role}</p>
              <p className="text-gray-600 nvidia-body text-center max-w-md">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
